import elementExists from '../../../core/utils/element-exists';
import eventBus from '../../../core/services/event-bus';
import ProductJSON from './product-json';
const ProductImages = () => {
    let variantImages = document.getElementById('variant-images');
    const featuredImage = document.getElementById('product-featured-image');
    const  original = featuredImage.dataset.familyImage;
    const showOriginal = document.getElementById('show-original');
    const showVariant = document.getElementById('show-variant');
    const variantToggle = document.querySelector('.variant-toggle');
    let { currentVariant  } = ProductJSON();
 

    if( elementExists( variantImages ) && elementExists( featuredImage ) ){  
        try{
            variantImages = JSON.parse(variantImages.innerHTML)
        }catch( $e ){
            variantImages = false;
        }
    }

    const showVariantImage = (  ) => {
        featuredImage.src = variantImages[currentVariant.id];
        showVariant.classList.add( 'active')
        showOriginal.classList.remove( 'active')
    }
    
    if( Object.keys(variantImages).length > 0 ){
        variantToggle.classList.add( 'active' )
        eventBus.on(eventBus.types.OptionsSelected , function( $event ){
            currentVariant = $event.detail;
            if( variantImages.hasOwnProperty( currentVariant.id ) ){
                showVariantImage();
            }else{
                featuredImage.src = original;
            }
        })
        showOriginal.addEventListener('click' , function( $event ){
            showVariant.classList.remove( 'active')
            showOriginal.classList.add( 'active')
            featuredImage.src = original;
        });
        showVariant.addEventListener('click' , function( $event ){
            showVariantImage();
        });
    }else{
        variantToggle.classList.add( 'd-none' )
    }
    if( showVariant.classList.contains('active') ){
        showVariantImage();
    }


}

export default ProductImages;

